const baseStyle = {
    bg: 'skyBlue.95'
};
const defaultProps = {
    size: 'md',
    variant: 'rect'
};
const sizes = {
    xs: {
        h: 24
    },
    sm: {
        h: 32
    },
    md: {
        h: 40
    },
    lg: {
        h: 48
    }
};
const variants = {
    circle: {
        borderRadius: '50%'
    },
    rect: {
        borderRadius: 'md',
        w: '100%'
    }
};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
